import _ from 'lodash';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { getNewPay, getMessage, setActiveStep, getPayFees, isLoading, setMessage } from 'state/reducers/pay.reducers';
import { getCountries, getCurrencies } from 'state/reducers/global.reducers';
//components
import { FormsStack } from 'theme/elements/Forms';
import { InfoCard } from 'theme/elements/Cards';
import { FormHeader1, FormHeadWithCheckbox } from 'theme/elements/Headers';
import { Paragraph3 } from 'theme/elements/Paragraphs';
//sections
import Footer from '../Footer';
//mui
import { Button, Checkbox, Stack, useTheme } from '@mui/material';
//constants
import { BeneficiaryDetailsBankAccount, paymentsMethodsDisplayList } from 'constants/beneficiary.constants';
import { Fragment, useMemo, useState } from 'react';
import { timing, userMessage } from 'constants/ui.constants';
import { CustomCheckbox } from 'theme/elements/Inputs';
import BeneficiaryNameWithFlag from 'sections/beneficiary/details/BeneficiaryNameWithFlag';
import {
	Pay,
	paySteps,
	PayEnum,
	PaymentFees,
	paymentsTypes,
	paymentReasonList,
	PaymentStatus,
} from 'constants/pay.constants';
import { format, isValid } from 'date-fns';
import { prepareObjectToValidate } from '../step2';
import { getUserDetails, getUserPermission } from 'state/reducers/user.reducers';
import { User, UserPermission } from 'constants/user.constants';
import { changePaymentStatus, createPayment } from 'services/pay.services';
import { useNavigate, useParams } from 'react-router-dom';
import WarningDialog from 'components/WarningDialog';
import { getPaymentById } from 'state/reducers/requests.reducers';
import { FormButton } from 'theme/elements/Buttons';
import { getFile } from 'services/global.services';
import { getFormattedNumber } from 'utils';
import { usePaymentCategoryDisplay } from 'hooks/custom.hooks';
import { formatCategoryTreeForDisplay } from 'utils/paymentCategoryUtils';

export default function Step3(props: { handleCancel: any; _payment?: Pay }) {
	const navigate = useNavigate();
	const user: User = useAppSelector(getUserDetails);
	const userMessage: userMessage = useAppSelector(getMessage);
	const Countries = _.keyBy(useAppSelector(getCountries), 'id');
	const Currencies = _.keyBy(useAppSelector(getCurrencies), 'id');
	const pay: Pay = useAppSelector(getNewPay);
	let { id } = useParams();
	const existingPayment = useAppSelector(getPaymentById(id!)) || {};
	let payment = props._payment ? props._payment : (existingPayment.id ? existingPayment : {
		...pay,
		[PayEnum.createdAt]: new Date(),
		[PayEnum.dueDate]: _.get(pay, PayEnum.paymentDate),
		file: _.get(pay, PayEnum.invoiceFile),
	});
	const beneficiary = payment?.beneficiary;
	const payFees: PaymentFees = useAppSelector(getPayFees);
	const beneficiaryBankDetails = useMemo(() => {
		let obj = {};
		BeneficiaryDetailsBankAccount.forEach((key) => {
			const value = _.get(beneficiary, key);
			if (value !== null && typeof value !== 'undefined') {
				obj[key] = String(value);
			}
		});
		return obj;
	}, [pay?.beneficiary]);
	const theme = useTheme();
	const dispatch = useAppDispatch();
	const t = useAppSelector(selectTranslations);
	const ifLoading = useAppSelector(isLoading);
	const userPermission = useAppSelector(getUserPermission);
	const [agree, setAgree] = useState(!_.isEqual(userPermission, UserPermission.SIGNER));
	const prefixFields = 'page.pay.create.step.3.';
	const prefixStep4 = 'page.pay.create.step.4.';
	const purposeCodes = useAppSelector((state) => state.global.paymentPurpose);
	const language = localStorage.getItem('language');
	const openDialog = useMemo(() => {
		return userMessage.exist;
	}, [userMessage]);

	// Always call hooks (React rules)
	const hookCategoryDisplay = usePaymentCategoryDisplay(
		beneficiary,
		pay[PayEnum.paymentCategory] || payment[PayEnum.paymentCategory]
	);

	// Format payment category from backend's categoryTree, or use hook fallback
	const paymentCategoryDisplay =
		payment.categoryTree && payment.categoryTree.length > 0
			? formatCategoryTreeForDisplay(payment.categoryTree, t)
			: hookCategoryDisplay;

	function formatValue(value?: any, key?: string) {
		let currency = Currencies[payment.beneficiary?.currencyId || ''] || {};
		switch (key) {
			case PayEnum.amount:
				return currency?.symbol + getFormattedNumber(value);
			case PayEnum.fee:
				return `${currency?.symbol}${
					_.get(payment, 'fee.amount')
						? getFormattedNumber(_.get(payment, 'fee.amount'))
						: getFormattedNumber(value)
				}`;
			case PayEnum.iban:
				return beneficiary?.iban;
			case PayEnum.paymentDate:
				return isValid(new Date(value)) ? format(new Date(), timing.DATE) : value;
			case PayEnum.paymentCategory:
				return value;
			case 'countryId':
			case 'bankAccountCountryId':
				return _.get(Countries[value || ''], 'name') || '';
			case 'currencyId':
				return _.get(Currencies[value || ''], 'name') || '';
				break;
			default:
				return value;
		}
	}
	const isPendingSigning = useMemo(() => {
		return (
			_.includes(UserPermission.SIGNER, userPermission) && payment?.status === PaymentStatus.AwaitingAuthorization
		);
	}, [payment, userPermission]);

	const paymentValues = useMemo(() => {
		{
			//createdAt :
		}
	}, [payment, pay]);

	return (
		<Fragment>
			<WarningDialog
				open={openDialog}
				title={t(userMessage.text || '')}
				subTitle={userMessage.subText}
				handleCancel={() => {
					dispatch(setMessage({ exist: false }));
				}}
			/>
			<FormsStack>
				<InfoCard>
					<Stack direction={'row'} justifyContent={'space-between'}>
						<FormHeader1 title={t(`${prefixFields}beneficiary_details.title`)} />
						{/*<FormButton autoheight autowidth >
                <Button 
                    variant='outlined'
                    onClick={() => navigate(`/${pagesEnum.BENEFICIARY}/details/${beneficiary?.id}`)}
                >
                    {t('portal.actions.view_profile')}
                </Button>
            </FormButton>*/}
					</Stack>
					<BeneficiaryNameWithFlag beneficiary={beneficiary || {}} />
				</InfoCard>
				<InfoCard>
					<Stack direction={'row'} justifyContent={'space-between'}>
						<FormHeader1 title={t(prefixFields + 'receipt.title')} />
						{_.has(payment, 'file') && _.has(payment, 'companyId') && (
							<FormButton autoheight="true" autowidth="true">
								<Button
									variant="outlined"
									onClick={() => {
										dispatch(
											getFile(
												_.get(payment, ['file', 'key']) || '',
												_.toNumber(_.get(payment, 'companyId'))
											)
										);
									}}
								>
									{t(prefixStep4 + 'invoice_file.text')}
								</Button>
							</FormButton>
						)}
					</Stack>
					<Stack spacing={2}>
						<Paragraph3
							color={theme.palette.root.basicDeepBlue}
							title={t(prefixStep4 + _.snakeCase(PayEnum.createdAt) + '.text')}
							text={
								isValid(new Date(_.get(payment, PayEnum.createdAt)))
									? format(new Date(_.get(payment, PayEnum.createdAt)), timing.DATE)
									: format(new Date(), timing.DATE)
							}
						/>
						<Paragraph3
							color={theme.palette.root.basicDeepBlue}
							title={t(prefixStep4 + _.snakeCase(PayEnum.dueDate) + '.text')}
							text={
								isValid(new Date(_.get(payment, PayEnum.dueDate) || 0))
									? format(new Date(_.get(payment, PayEnum.dueDate) || 0), timing.DATE)
									: _.get(payment, PayEnum.dueDate)
							}
						/>
						<Paragraph3
							color={theme.palette.root.basicDeepBlue}
							title={t(prefixFields + PayEnum.amount + '.text')}
							text={formatValue(payment[PayEnum.amount], PayEnum.amount)}
						/>
						<Paragraph3
							color={theme.palette.root.basicDeepBlue}
							title={t(prefixFields + PayEnum.fee + '.text')}
							text={formatValue(payment[PayEnum.fee], PayEnum.fee)}
						/>
						<Paragraph3
							color={theme.palette.root.basicDeepBlue}
							title={t(prefixFields + _.snakeCase(PayEnum.paymentType) + '.text')}
							text={t(
								prefixFields +
									_.snakeCase(PayEnum.paymentType) +
									'.' +
									_.lowerCase(payment.type || _.get(payment, PayEnum.paymentType)) +
									'.text'
							)}
						/>
						{_.isEqual(payment.paymentType, paymentsTypes.PRIORITY) && (
							<Paragraph3
								color={theme.palette.root.basicDeepBlue}
								title={t(prefixFields + PayEnum.swift + '.text')}
								text={t(prefixFields + PayEnum.swift + '.' + payment.swift + '.text')}
							/>
						)}
						{paymentCategoryDisplay && (
							<Paragraph3
								color={theme.palette.root.basicDeepBlue}
								title={t('page.pay.create.step.3.payment_category.title')}
								text={paymentCategoryDisplay}
							/>
						)}
						{!paymentCategoryDisplay && payment[PayEnum.paymentCategory] && (
							<Paragraph3
								color={theme.palette.root.basicDeepBlue}
								title={t('page.pay.create.step.3.payment_category.title')}
								text={formatValue(payment[PayEnum.paymentCategory], PayEnum.paymentCategory)}
							/>
						)}

						{payment[PayEnum.comment] && (
							<Paragraph3
								color={theme.palette.root.basicDeepBlue}
								title={t(prefixFields + _.snakeCase(PayEnum.comment) + '.text')}
								text={payment[PayEnum.comment]}
							/>
						)}
						{payment[PayEnum.reference] && (
							<Paragraph3
								color={theme.palette.root.basicDeepBlue}
								title={t(prefixFields + _.snakeCase(PayEnum.reference) + '.text')}
								text={payment[PayEnum.reference]}
							/>
						)}

						{payment[PayEnum.invoiceNumber] && (
							<Paragraph3
								color={theme.palette.root.basicDeepBlue}
								title={t(prefixStep4 + _.snakeCase(PayEnum.invoiceNumber) + '.text')}
								text={String(payment[PayEnum.invoiceNumber])}
							/>
						)}
					</Stack>
				</InfoCard>

				<InfoCard>
					<FormHeader1 title={t(`${prefixFields}bank_account_details.title`)} />
					<Stack spacing={2}>
						{_.keys(beneficiaryBankDetails).map((field) => {
							return (
								<Paragraph3
									key={field}
									color={theme.palette.root.basicDeepBlue}
									title={t(`${prefixFields}bank_account_details.${_.snakeCase(field)}.text`)}
									text={formatValue(_.get(beneficiaryBankDetails, field), field)}
								/>
							);
						})}
						{paymentsMethodsDisplayList.map((field) => {
							return !_.isNil(_.get(beneficiary, field)) ? (
								<Paragraph3
									key={field}
									//color={theme.palette.root.basicDeepBlue}
									title={t(`${prefixFields}bank_account_details.${_.snakeCase(field)}.text`)}
									text={formatValue(_.get(beneficiary, field), field)}
								/>
							) : (
								<Fragment key={field}></Fragment>
							);
						})}
					</Stack>
				</InfoCard>
				<>
					{_.isEqual(userPermission, UserPermission.SIGNER) && (
						<InfoCard>
							<FormHeadWithCheckbox>
								<CustomCheckbox>
									<Checkbox
										sx={{ padding: 0, alignItems: 'start' }}
										onChange={(event) => {
											setAgree(event.target.checked);
										}}
										checked={agree}
									/>
								</CustomCheckbox>
								<Paragraph3
									title={t(`${prefixFields}disclaimer.title`)}
									text={t(`${prefixFields}disclaimer.text`)}
								/>
							</FormHeadWithCheckbox>
						</InfoCard>
					)}
				</>
				<Footer
					handleCancel={props.handleCancel}
					handleBack={() => {
						dispatch(setActiveStep(paySteps.PAYMENT_DETAILS));
					}}
					ifBack={true}
					disableSubmit={!agree || ifLoading}
					disableCancel={ifLoading}
					disableBack={isPendingSigning || ifLoading}
					labelSubmit={
						isPendingSigning ? t(`${prefixFields}sign_button.text`) : t(`${prefixFields}submit_button.text`)
					}
					labelBack={t(`${prefixFields}back_button.text`)}
					labelCancel={t(`${prefixFields}cancel_button.text`)}
					handleSubmit={() => {
						if (isPendingSigning) {
							dispatch(changePaymentStatus(payment.id, PaymentStatus.Approved));
							dispatch(setActiveStep(paySteps.COMPLETE));
						} else {
							dispatch(createPayment(prepareObjectToValidate(pay, user, true)));
						}
					}}
				/>
			</FormsStack>
		</Fragment>
	);
}
